import AppointmentStatusCell from './appointment_status_cell';

export default AppointmentStatusCell;
